import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { username: String }

  editField(event) {
    const field = event.currentTarget.dataset.field
    const container = this.element.querySelector(`[data-inline-field="${field}"]`)
    if (!container) return

    container.querySelector('[data-role="display"]')?.classList.add('hidden')
    container.querySelector('[data-role="edit"]')?.classList.remove('hidden')

    const input = container.querySelector('input, textarea')
    if (input) {
      input.focus()
      if (input.select) input.select()
    }
  }

  cancelField(event) {
    const field = event.currentTarget.dataset.field
    const container = this.element.querySelector(`[data-inline-field="${field}"]`)
    if (!container) return

    container.querySelector('[data-role="display"]')?.classList.remove('hidden')
    container.querySelector('[data-role="edit"]')?.classList.add('hidden')
  }

  async saveField(event) {
    event.preventDefault()
    const field = event.currentTarget.dataset.field
    const container = this.element.querySelector(`[data-inline-field="${field}"]`)
    if (!container) return

    const input = container.querySelector('input, textarea')
    if (!input) return

    const value = input.value
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(`/${this.usernameValue}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': token
        },
        body: JSON.stringify({ user: { [field]: value } })
      })

      const data = await response.json()
      if (!response.ok || !data.success) throw new Error((data.errors || []).join(', ') || 'Save failed')

      const next = data.user?.[field] || ''
      const displayValue = container.querySelector('[data-role="display-value"]')
      if (displayValue) {
        if (field === 'website') {
          if (next) {
            const href = this.safeUrl(next)
            const label = this.escapeHtml(next)
            displayValue.innerHTML = href
              ? `<a href="${href}" target="_blank" rel="noopener noreferrer" class="text-purple-300 hover:text-purple-200">${label}</a>`
              : `<span class="text-purple-300">${label}</span>`
          } else {
            displayValue.textContent = 'Add website'
          }
        } else if (field === 'location') {
          displayValue.textContent = next || 'Add location'
        } else {
          displayValue.textContent = next || (field === 'bio' ? 'No bio yet' : '')
        }
      }

      container.querySelector('[data-role="display"]')?.classList.remove('hidden')
      container.querySelector('[data-role="edit"]')?.classList.add('hidden')
    } catch (e) {
      alert(e.message || 'Could not save field')
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text == null ? "" : String(text)
    return div.innerHTML
  }

  safeUrl(url) {
    if (!url) return ""
    const raw = String(url).trim()
    if (/^(https?:\/\/|\/)/i.test(raw)) {
      return raw.replace(/"/g, "%22").replace(/</g, "%3C").replace(/>/g, "%3E")
    }
    return ""
  }
}
